// src/components/learning/ExercisesHub.js
// Menu principal des exercices par niveau

import React, { useState } from 'react';
import { exercisesData } from './exercisesData';
import ExerciseGame from './ExerciseGame';

const ExercisesHub = ({ onClose }) => {
  const [selectedLevel, setSelectedLevel] = useState(null);
  const [selectedExercise, setSelectedExercise] = useState(null);

  const levels = [
    exercisesData.beginner,
    exercisesData.intermediate,
    exercisesData.advanced
  ];

  // Si un exercice est sélectionné, afficher le jeu
  if (selectedExercise) {
    return (
      <ExerciseGame
        exercise={selectedExercise}
        onClose={() => setSelectedExercise(null)}
        onComplete={(score) => {
          console.log('Exercise completed with score:', score);
        }}
      />
    );
  }

  // Si un niveau est sélectionné, afficher les exercices
  if (selectedLevel) {
    return (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.95)',
        zIndex: 9999,
        overflow: 'auto'
      }}>
        {/* Header */}
        <div style={{
          padding: '1.5rem',
          background: `linear-gradient(135deg, ${selectedLevel.color}40 0%, ${selectedLevel.color}20 100%)`,
          borderBottom: `2px solid ${selectedLevel.color}`,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            <button
              onClick={() => setSelectedLevel(null)}
              style={{
                background: 'rgba(255,255,255,0.1)',
                border: 'none',
                borderRadius: '8px',
                padding: '0.5rem 1rem',
                color: 'white',
                cursor: 'pointer',
                fontSize: '1.2rem'
              }}
            >
              ←
            </button>
            <span style={{ fontSize: '2.5rem' }}>{selectedLevel.icon}</span>
            <div>
              <h2 style={{ margin: 0, color: 'white', fontSize: '1.5rem' }}>
                Niveau {selectedLevel.name}
              </h2>
              <p style={{ margin: 0, color: 'rgba(255,255,255,0.7)', fontSize: '1rem' }}>
                {selectedLevel.nameAr} - {selectedLevel.description}
              </p>
            </div>
          </div>
          
          <button
            onClick={onClose}
            style={{
              background: 'rgba(255,255,255,0.1)',
              border: 'none',
              borderRadius: '50%',
              width: '40px',
              height: '40px',
              color: 'white',
              cursor: 'pointer',
              fontSize: '1.2rem'
            }}
          >
            ✕
          </button>
        </div>

        {/* Liste des exercices */}
        <div style={{
          padding: '2rem',
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
          gap: '1.5rem',
          maxWidth: '1200px',
          margin: '0 auto'
        }}>
          {selectedLevel.exercises.map((exercise) => (
            <div
              key={exercise.id}
              onClick={() => setSelectedExercise(exercise)}
              style={{
                background: 'linear-gradient(135deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.05) 100%)',
                borderRadius: '16px',
                padding: '2rem',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                border: '2px solid rgba(255,255,255,0.1)',
                position: 'relative',
                overflow: 'hidden'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-5px)';
                e.currentTarget.style.borderColor = selectedLevel.color;
                e.currentTarget.style.boxShadow = `0 10px 30px ${selectedLevel.color}30`;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.borderColor = 'rgba(255,255,255,0.1)';
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              {/* Badge nombre de questions */}
              <div style={{
                position: 'absolute',
                top: '1rem',
                right: '1rem',
                background: selectedLevel.color,
                padding: '0.25rem 0.75rem',
                borderRadius: '12px',
                fontSize: '0.8rem',
                color: 'white',
                fontWeight: 'bold'
              }}>
                {exercise.questions.length} questions
              </div>

              <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>
                {exercise.icon}
              </div>
              
              <h3 style={{ 
                margin: '0 0 0.5rem 0', 
                color: 'white',
                fontSize: '1.4rem'
              }}>
                {exercise.name}
              </h3>
              
              <p style={{ 
                margin: 0, 
                color: 'rgba(255,255,255,0.6)',
                fontSize: '1rem'
              }}>
                {exercise.description}
              </p>
              
              <div style={{
                marginTop: '1.5rem',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                color: selectedLevel.color,
                fontWeight: 'bold'
              }}>
                <span>Commencer</span>
                <span>→</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  // Menu principal - Choix du niveau
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.95)',
      zIndex: 9999,
      overflow: 'auto'
    }}>
      {/* Header */}
      <div style={{
        padding: '1.5rem',
        background: 'linear-gradient(135deg, #667eea40 0%, #764ba220 100%)',
        borderBottom: '2px solid #667eea',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          <span style={{ fontSize: '2.5rem' }}>🎮</span>
          <div>
            <h2 style={{ margin: 0, color: 'white', fontSize: '1.5rem' }}>
              Exercices Interactifs
            </h2>
            <p style={{ margin: 0, color: 'rgba(255,255,255,0.7)', fontSize: '1rem' }}>
              تمارين تفاعلية - Apprends en t'amusant !
            </p>
          </div>
        </div>
        
        <button
          onClick={onClose}
          style={{
            background: 'rgba(255,255,255,0.1)',
            border: 'none',
            borderRadius: '50%',
            width: '40px',
            height: '40px',
            color: 'white',
            cursor: 'pointer',
            fontSize: '1.2rem'
          }}
        >
          ✕
        </button>
      </div>

      {/* Choix du niveau */}
      <div style={{
        padding: '3rem 2rem',
        maxWidth: '1000px',
        margin: '0 auto'
      }}>
        <h3 style={{ 
          textAlign: 'center', 
          color: 'white', 
          fontSize: '1.8rem',
          marginBottom: '0.5rem'
        }}>
          Choisis ton niveau
        </h3>
        <p style={{
          textAlign: 'center',
          color: 'rgba(255,255,255,0.6)',
          marginBottom: '3rem'
        }}>
          Commence par le niveau débutant si tu découvres l'arabe
        </p>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
          gap: '2rem'
        }}>
          {levels.map((level) => (
            <div
              key={level.id}
              onClick={() => setSelectedLevel(level)}
              style={{
                background: `linear-gradient(135deg, ${level.color}20 0%, ${level.color}10 100%)`,
                borderRadius: '24px',
                padding: '2.5rem',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                border: `3px solid ${level.color}40`,
                textAlign: 'center'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-10px) scale(1.02)';
                e.currentTarget.style.borderColor = level.color;
                e.currentTarget.style.boxShadow = `0 20px 40px ${level.color}30`;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0) scale(1)';
                e.currentTarget.style.borderColor = `${level.color}40`;
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              <div style={{ 
                fontSize: '5rem', 
                marginBottom: '1rem',
                filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.3))'
              }}>
                {level.icon}
              </div>
              
              <h3 style={{ 
                margin: '0 0 0.5rem 0', 
                color: 'white',
                fontSize: '1.8rem'
              }}>
                {level.name}
              </h3>
              
              <p style={{
                margin: '0 0 0.5rem 0',
                color: level.color,
                fontSize: '1.2rem',
                fontFamily: "'Amiri', serif"
              }}>
                {level.nameAr}
              </p>
              
              <p style={{ 
                margin: '0 0 1.5rem 0', 
                color: 'rgba(255,255,255,0.6)',
                fontSize: '1rem'
              }}>
                {level.description}
              </p>
              
              <div style={{
                background: level.color,
                padding: '0.75rem 1.5rem',
                borderRadius: '12px',
                color: 'white',
                fontWeight: 'bold',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.5rem'
              }}>
                {level.exercises.length} exercices
                <span>→</span>
              </div>
            </div>
          ))}
        </div>

        {/* Stats / Motivation */}
        <div style={{
          marginTop: '3rem',
          padding: '2rem',
          background: 'rgba(255,255,255,0.05)',
          borderRadius: '16px',
          textAlign: 'center'
        }}>
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '3rem',
            flexWrap: 'wrap'
          }}>
            <div>
              <div style={{ fontSize: '2.5rem', color: '#10b981', fontWeight: 'bold' }}>
                {levels.reduce((acc, l) => acc + l.exercises.length, 0)}
              </div>
              <div style={{ color: 'rgba(255,255,255,0.6)' }}>Exercices</div>
            </div>
            <div>
              <div style={{ fontSize: '2.5rem', color: '#f59e0b', fontWeight: 'bold' }}>
                {levels.reduce((acc, l) => acc + l.exercises.reduce((a, e) => a + e.questions.length, 0), 0)}
              </div>
              <div style={{ color: 'rgba(255,255,255,0.6)' }}>Questions</div>
            </div>
            <div>
              <div style={{ fontSize: '2.5rem', color: '#667eea', fontWeight: 'bold' }}>
                🏆
              </div>
              <div style={{ color: 'rgba(255,255,255,0.6)' }}>Badges à gagner</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExercisesHub;
